import { render } from "./Launcher.vue?vue&type=template&id=70c130e9"
import script from "./Launcher.vue?vue&type=script&lang=js"
export * from "./Launcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__